module.exports = __webpack_public_path__ + "assets/6feafb6e081e95d991c09b52b42cff64.mp3";